module.exports = __webpack_public_path__ + "img/pointRank.d59500bf.png";